import { useLocation } from "react-router-dom"
import { useMemo } from "react"
import cn from "classnames"

import { createPath, isCalendarReady } from "../helpers"
import { useAuthContext } from "../AuthContext"
import { PsyAvatar } from "../PsyAvatar"

import style from "./style.module.scss"
import { DesktopMenu } from "./DesktopMenu"
import { MobileMenu } from "./MobileMenu"
import { HeaderQualityLabel } from "./HeaderQualityLabel"

import { HeaderLogo, HeaderRoot } from "components/Header"
import {
    useAccountDetailsQuery,
    useCalendarsQuery,
} from "modules/PsychologistAccount/common/queries"

interface Props {
    marginBottom?: boolean
}

export function PsyAccHeader({ marginBottom = false }: Props) {
    const location = useLocation()
    const [, { isSignedIn }] = useAuthContext()
    const { data: accountDetails, isLoading } = useAccountDetailsQuery()
    const { data: calendars } = useCalendarsQuery(!!accountDetails, false)
    const isCalendarReadyConst =
        accountDetails && calendars && isCalendarReady(accountDetails, calendars)

    const isClientsFeedbackEnabled = accountDetails?.profile.collect_clients_feedback || false

    const getPath = useMemo(() => {
        if (!isSignedIn) return () => createPath("/login")
        if (!isCalendarReadyConst) return () => createPath("/settings")
        return (path: string) => createPath(path)
    }, [isCalendarReadyConst, isSignedIn])

    if (!accountDetails || isLoading) return null

    return (
        <HeaderRoot className={cn({ [style.marginBottom]: marginBottom })}>
            <HeaderQualityLabel />
            <HeaderLogo>alter</HeaderLogo>
            <div className={style.wrapper}>
                <DesktopMenu
                    getPath={getPath}
                    isClientsFeedbackEnabled={isClientsFeedbackEnabled}
                />
                <PsyAvatar
                    name={accountDetails.profile.display_name}
                    isAdaptive
                    dataTestId={"header-psy-avatar"}
                />
                <MobileMenu
                    key={location.key}
                    getPath={getPath}
                    isClientsFeedbackEnabled={isClientsFeedbackEnabled}
                    accountDetails={accountDetails}
                />
            </div>
        </HeaderRoot>
    )
}
